import { useEffect } from "react"
import Image from "@/components/Shared/Image"
import CloseIcon from "@/public/icons/modal-close.svg"
import Button from "@/components/core/Button/Button"
import Styles from "@/components/MyFavorites/v1/MyList/ListInventoryCheckModal/index.module.scss"
import MissingImage from "@/public/images/image-missing.png"
import { getPresetUrl } from "@/utils/index"
import useWindowResize from "@/hooks/useWindowResize"
import { removeMavenoidChat, addMavenoidChat } from "@/utils/helper"
import ColorSwatchSelected from "@/components/MyFavorites/v1/MyList/ColorSwatchSelected/v1/index.jsx"
import cx from "classnames"
import {
  getColors,
  getLineItemsProductImage,
} from "@/components/MyFavorites/v1/MyList/helper"

const ListInventoryCheckModal = props => {
  const {
    closeInventoryCheckModal = () => {},
    general,
    presetConfigs,
    productData = [],
    siteName,
    productQtyObj,
    staticText,
    flewItemsLessStock,
    allItemsOutOfStock,
    handleAvailableItemsToCart = () => {},
  } = props
  const [width] = useWindowResize()

  useEffect(() => {
    removeMavenoidChat()
    return () => {
      const moreOptions = document.querySelector(".more-options")
      if (
        moreOptions &&
        window.getComputedStyle(moreOptions).display === "none"
      ) {
        addMavenoidChat()
      }
    }
  }, [])

  const getOutOffStockText = product => {
    if (product?.stockStatus === "Less Stock") {
      return `${product?.inventory} ${staticText?.lessStock}`
    } else if (product?.stockStatus === "Out of Stock") {
      return staticText?.outOfStock
    }
    return ""
  }
  return (
    <div className={Styles.ListInventoryCheckModalWrapper}>
      <div className="modal-container" data-testid="modal-container">
        <div className="modal-body-wrapper">
          <div className="close-modal-btn" onClick={closeInventoryCheckModal}>
            <Image
              src={CloseIcon?.src}
              role="presentation"
              alt="close"
              width="16"
              height="16"
            />
          </div>
          <div className="header-container-wrapper">
            <div className="title">{staticText?.quantityModelHeader}</div>
            <div className="description">
              {staticText?.quantityModelSubHeader}
            </div>
          </div>
          <div className="items-header">
            <div>{staticText?.item}</div>
            <div>{staticText?.quantity}</div>
          </div>
          <div className="product-container-wrapper">
            <div className="mobile-divider"></div>
            {productData.map((product, index) => {
              const imageUrl = product?.["productImages.url_ss"] ?? []
              const sku = product?.["masterSKU_s"] ?? ""
              const images = getLineItemsProductImage(product, sku)
              const colors = getColors(product)
              return (
                <div
                  className="product-container"
                  key={index}
                  data-testid="inventory-item"
                >
                  <div className="image-container">
                    <a
                      role="button"
                      onClick={e => {}}
                      data-testid="view-product"
                    >
                      <div className="list-image-tile">
                        {imageUrl?.[0] && images?.length > 0 ? (
                          images?.map((id, i) => {
                            const imgUrl = getPresetUrl(
                              width,
                              0,
                              general.swatchUrl,
                              id,
                              JSON.parse(presetConfigs)
                            )
                            return (
                              <img
                                className="list-image"
                                key={id + "_IMG_" + i}
                                id={id + "_IMG_" + i}
                                role="presentation"
                                src={imgUrl}
                                imgsrc={imgUrl}
                              />
                            )
                          })
                        ) : (
                          <Image
                            className="list-image"
                            src={MissingImage}
                            alt="missing-image"
                          />
                        )}
                      </div>
                    </a>
                  </div>
                  <div className="details-container">
                    <div className="brand" data-testid="brand">
                      {siteName?.toUpperCase()}
                    </div>
                    <div className="name" data-testid="name">
                      {product?.["Tile_Title"] ?? ""}
                    </div>
                    {colors && colors[0]?.name === "Not Applicable" ? null : (
                      <div className="color-text-main">
                        <ColorSwatchSelected
                          colors={colors}
                          cx={cx}
                          general={general}
                          mobile={false}
                          customText={staticText?.colorAndFinish}
                        />
                      </div>
                    )}
                    <div
                      className="sku-text"
                      data-testid="sku"
                    >{`SKU: ${sku}`}</div>
                    <div className="status" data-testid="status">
                      {getOutOffStockText(product)}
                    </div>
                  </div>
                  <div className="quantity-container">
                    <div className="quantity-text" data-testid="quantity">
                      {productQtyObj[sku] ?? 1}
                    </div>
                  </div>
                </div>
              )
            })}
          </div>
          <div className="button-container">
            {flewItemsLessStock ? (
              <Button
                role="button"
                size="small"
                flexible
                type="ghost"
                className="add-cart"
                onClick={() =>
                  handleAvailableItemsToCart(
                    staticText?.addAvailableItemsToCart
                  )
                }
                label={staticText?.addAvailableItemsToCart}
                data-testid="add-to-cart"
              />
            ) : null}
            <Button
              role="button"
              size="small"
              flexible
              type="ghost"
              className={allItemsOutOfStock ? "close-black" : "close-empty"}
              label={staticText?.close}
              onClick={closeInventoryCheckModal}
              data-testid="close-modal"
            />
          </div>
        </div>
      </div>
    </div>
  )
}

export default ListInventoryCheckModal
